import { render, staticRenderFns } from "./CompareWithTag.vue?vue&type=template&id=03385c78"
import script from "./CompareWithTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareWithTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareWithTag.vue?vue&type=style&index=0&id=03385c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports